import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import { observable } from 'mobx';
import { Model } from 'core/model/Model';
import { DeviceEventKeys } from '@kentik/ui-shared/device/constants';
import { PagedCollection } from 'core/model/PagedCollection';
export let DeviceSyslogsCollection = (_dec = observable.ref, _class = class DeviceSyslogsCollection extends PagedCollection {
  get model() {
    return Model;
  }
  constructor(device) {
    super();
    _initializerDefineProperty(this, "device", _descriptor, this);
    this.device = device;
    this.serverSortableFields = [DeviceEventKeys.timestamp, DeviceEventKeys.format, DeviceEventKeys.transport, DeviceEventKeys.dataset, DeviceEventKeys.severity, DeviceEventKeys.facility];
    this.setPageState({
      perPage: 20
    });
    this.requestStatus = 'awaitingRequest';
  }
  get url() {
    return `/api/ui/devices/${this.device.id}/syslog/query`;
  }
  get fetchMethod() {
    return 'post';
  }
  get jsonRoot() {
    return 'data';
  }
  get queuedFetchKey() {
    return `DeviceSyslogsCollection.${this.device.id}`;
  }
  get defaultSortState() {
    return {
      field: DeviceEventKeys.timestamp,
      direction: 'desc'
    };
  }
  get sortParam() {
    const {
      field,
      direction
    } = this.sortState;
    return {
      field,
      direction
    };
  }

  /**
   * Sorting is applied by the Table, which re-fetches via `pagedFetch` whenever `sortParam` changes
   * (including the filters, window, search and pagination). The base implementation would fire a second,
   * un-queued request with only `{ force, offset, sortBy }`, racing the real one and overwriting its results.
   */
  serverSortFn() {
    return Promise.resolve();
  }
  processData(response) {
    const result = super.processData(response);
    this.setPageState({
      pageCountLoaded: true
    });
    return result;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "device", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);